import { render, staticRenderFns } from "./FormAccesos.vue?vue&type=template&id=4d0d5165"
import script from "./FormAccesos.vue?vue&type=script&lang=js"
export * from "./FormAccesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports